import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
export default function ServicesHero() {
  return <section id="services-hero" className="relative w-full min-h-screen flex flex-col overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/header_and_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/header_and_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/header_and_hero.png-wvc-sizes" alt="Industrial mining equipment background" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-black/70" />
      </div>

      {}
      <div className="page-container relative z-10 flex flex-col flex-1 py-8 md:py-12">
        
        {}
        <div className="flex justify-between items-start w-full">
          <Badge variant="default" className="text-sm md:text-base py-1.5 px-4 uppercase tracking-wider font-semibold shadow-md">
            30 Years Anniversary
          </Badge>
          
          <Link to="/">
            <img src="/img/company_logo_light.png" alt="Company Logo" className="h-8 md:h-10 w-auto drop-shadow-md" />
          </Link>
        </div>

        {}
        <div className="flex-1 flex flex-col justify-center max-w-4xl mt-16 md:mt-0">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-default font-bold text-white leading-tight mb-6 drop-shadow-sm">
            Powering the Future of Mining Operations
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-8 max-w-2xl font-sans drop-shadow-sm">
            Three decades of delivering robust industrial equipment and comprehensive service solutions for the most demanding environments.
          </p>
        </div>
        
      </div>
    </section>;
}